import React, { useState, useEffect, useRef } from "react";
import { Dialog, CircularProgress } from "@mui/material";
import PatientFileImg from "../../components/PatientFileImg";

const EmployeePhotoModal = ({ open, onClose, images }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [loading, setLoading] = useState(true);
  const startX = useRef(null);

  // Reset when modal opens
  useEffect(() => {
    if (open) {
      setCurrentIndex(0);
      setLoading(true);
    }
  }, [open]);

  // Reset loading whenever index changes
  useEffect(() => {
    setLoading(true);
  }, [currentIndex]);

  // Navigation
  const handlePrev = () =>
    setCurrentIndex((prev) =>
      prev === 0 ? images.length - 1 : prev - 1
    );

  const handleNext = () =>
    setCurrentIndex((prev) =>
      prev === images.length - 1 ? 0 : prev + 1
    );

  // Swipe support for mobile
  const handleTouchStart = (e) => (startX.current = e.touches[0].clientX);
  const handleTouchEnd = (e) => {
    if (!startX.current) return;
    const endX = e.changedTouches[0].clientX;
    const diff = startX.current - endX;
    if (diff > 50) handleNext();
    else if (diff < -50) handlePrev();
    startX.current = null;
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <div className="p-6 bg-white rounded-lg">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-semibold">Employee Photos</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 text-xl"
          >
            ×
          </button>
        </div>

        <div
          className="flex flex-col items-center justify-center"
          onTouchStart={handleTouchStart}
          onTouchEnd={handleTouchEnd}
        >
          {images && images.length > 0 ? (
            <>
      <div className="w-56 h-56 rounded-full border-2 border-black relative bg-gray-100 overflow-hidden flex items-center justify-center">
  {loading && (
    <div className="absolute inset-0 flex items-center justify-center bg-gray-100">
      <CircularProgress size={32} />
    </div>
  )}
  <PatientFileImg
    stored={images[currentIndex]}
    folder="emp_onboarding"
    onError={() => setLoading(false)}
    alt={`Employee ${currentIndex + 1}`}
    className={`w-full h-full object-cover transition-opacity duration-300 ${
      loading ? "opacity-0" : "opacity-100"
    }`}
    onLoad={() => setLoading(false)}
  />
</div>


              <div className="flex items-center justify-between w-full mt-6 px-6">
                <button
                  onClick={handlePrev}
                  className="px-4 py-2 rounded-md bg-gray-200 hover:bg-gray-300 text-gray-700"
                >
                  Previous
                </button>
                <span className="text-sm text-gray-500">
                  {currentIndex + 1} / {images.length}
                </span>
                <button
                  onClick={handleNext}
                  className="px-4 py-2 rounded-md bg-gray-200 hover:bg-gray-300 text-gray-700"
                >
                  Next
                </button>
              </div>
            </>
          ) : (
            <p className="text-gray-500 text-center">No photos available</p>
          )}
        </div>
      </div>
    </Dialog>
  );
};

export default EmployeePhotoModal;
